// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__7F8JX","empty":"ModalGraph_empty__134Km"};